export const parseJwt = (token) => {
  try {
    if (!token) return null;

    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => `%${("00" + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    return null;
  }
};

export const getUserIdFromToken = () => {
  try {
    const token = localStorage.getItem("authToken");
    if (!token) return null;

    const payload = parseJwt(token);
    return payload?.userId || null;
  } catch (error) {
    return null;
  }
};

export const formatDOB = (timestamp) => {
  if (!timestamp) return "DOB not available";

  const date = new Date(timestamp);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const isTokenExpired = () => {
  const token = localStorage.getItem("authToken");
  if (!token) return true;

  const payload = parseJwt(token);
  if (!payload?.exp) return true;

  return payload.exp * 1000 < Date.now();
};

export const calculateAge = (dob) => {
  if (!dob) return "";
  const diff = Date.now() - dob;
  return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
};
